import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { AppState } from "../RootReducer";
import { isHomeScreen, usePrevious } from "./ui/utils";
import { AcceptedRoutes } from "../http/Types";

const setBodyClassByPath = (currentPath : string, prevPath? : string) => {
    if(prevPath) {
      let toRemove = getPartsFromPath(prevPath);
      if (toRemove.length > 0) {
        document.body.classList.remove(...toRemove)
      }
    }
    let toAdd = getPartsFromPath(currentPath);
    if(toAdd.length > 0) {
      document.body.classList.add(...toAdd)
    }

}
export const getPartsFromPath = (path? : string) => {
  if(!path || path.trim().length == 0) {
    return []
  }
  let parts = path.split("/");
  let result = parts.filter(p => p && p.trim().length > 0)
      .map(p => "pn-" + p.trim().toLowerCase().replace(/([^a-zA-Z0-9-_])/g, ""))
      .filter(p => p.length > 0);
  return result;
}

const LastVisitedRoute = () => {
  const location = useLocation();
  const prevLocation = usePrevious(location.pathname);
  const settings = useSelector((state: AppState) => state.settings.settings);

  const enabledSections = {
    casino: settings?.casinoEnabled,
    racing: settings?.racingEnabled,
    sportsbook: settings?.sportsbookEnabled,
    poker: settings?.pokerEnabled,
  };

  const enabled = new Map(Object.entries(enabledSections));

  useEffect(() => {
      if(location.pathname != prevLocation) {
          setBodyClassByPath(location.pathname, prevLocation);
      }
  }, [location.pathname]);

  useEffect(()=>{
    localStorage.setItem("previousPath", `${prevLocation}`);
  },[location.pathname])

  useEffect(() => {
    if (prevLocation !== location.pathname && isHomeScreen()) {
      Object.entries(AcceptedRoutes).forEach(([_, val]) => {
        if (location.pathname.includes(val) && enabled.get(val)) {
          if(val === AcceptedRoutes.CASINO && !location.pathname.includes('play')){
          return localStorage.setItem("LAST_VISITED_ROUTE", `${location.pathname}`);
          }
          return localStorage.setItem("LAST_VISITED_ROUTE", `/${val}`);
        }
      });
    }
  }, [location]);

  return null;
};

export default LastVisitedRoute;
